import * as Sentry from '@sentry/nextjs';

import { callQueries } from '@/utils/callQueries.helpers';
import { GetOfficeFiltersDocument } from '@graphql/hooks-and-types';

export const getAvailableFilters = async (clientName: string, terminology: string) => {
  try {
    const responses = await callQueries({
      queries: [
        { query: GetOfficeFiltersDocument, variables: { data: { terminology: terminology?.toLocaleLowerCase() } } },
      ],
      clientName,
    });
    return responses[0].data.getOfficeFilters;
  } catch (error: any) {
    Sentry.captureException(error);
  }
};
